import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row items-center cursor-pointer" }
const _hoisted_2 = { class: "text-space-b-100 fs-15px fw-500 q-ml-xs" }

interface IProps {
  title: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseAddMore' },
  __name: 'BaseAddMore',
  props: {
    title: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_icon, {
      name: "plus-rounded",
      color: "space-b-100"
    }),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
  ]))
}
}

})